var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle-icon-container append-right-default align-self-start align-self-lg-center"},[_c('icon',{attrs:{"name":_vm.name}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }